import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  getObjRscRsltInfo(selectType, managetypeId, managetypeKey, objTotal, objIds, serviceObjIds, rscInfoList, rscKeyInfoList, limit) {
    return axios.post(`${baseUrl}/dashboard/widget/get-rsc-rslt-info.do`, {
      selectType,
      managetypeId,
      managetypeKey,
      objTotal,
      objIds,
      serviceObjIds,
      rscInfoList,
      rscKeyInfoList,
      limit,
    });
  },
  getQueryRscRsltInfo(selectType, queryId) {
    return axios.post(`${baseUrl}/dashboard/widget/get-rsc-rslt-info.do`, {
      selectType,
      queryId,
    });
  },
  getRscTree(managetypeId, managetypeKey, onlyPredictTarget) {
    return axios.get(`${baseUrl}/dashboard/widget/get-rsc-tree.do`, {
      params: {
        managetypeId,
        managetypeKey,
        onlyPredictTarget,
      },
    });
  },
  getObjRscKey(managetypeId, objId, rsctypeId, rscId, onlyPredictTarget) {
    return axios.get(`${baseUrl}/dashboard/widget/get-obj-rsc-key.do`, {
      params: {
        managetypeId,
        objId,
        rsctypeId,
        rscId,
        onlyPredictTarget,
      },
    });
  },
  getObjOrderNRsltInfo(selectType, selectedObjType, managetypeId, managetypeKey, objTotal, objIds, serviceObjIds, rscInfoList, rscKeyInfoList, order, limit) {
    return axios.post(`${baseUrl}/dashboard/widget/get-ordern-rslt-info.do`, {
      selectType,
      selectedObjType,
      managetypeId,
      managetypeKey,
      objTotal,
      objIds,
      serviceObjIds,
      rscInfoList,
      rscKeyInfoList,
      order,
      limit,
    });
  },
  getQueryOrderNRsltInfo(selectType, queryId) {
    return axios.post(`${baseUrl}/dashboard/widget/get-ordern-rslt-info.do`, {
      selectType,
      queryId,
    });
  },
  getEventStatusList(viewType, managegroupIds, managetypeIds, managetypeTotal, managegroupTotal, limit, eventListColumnList, eventlevelType, eventlevelIds) {
    return axios.post(`${baseUrl}/dashboard/widget/get-event-status-list.do`, {
      viewType,
      managegroupIds,
      managetypeIds,
      managetypeTotal,
      managegroupTotal,
      eventListColumnList,
      limit,
      eventlevelType,
      eventlevelIds,
    });
  },
  getKeyInfoList(objDefineId, managetypeId, managegroupTotal, managegroupIds, limit) {
    return axios.post(`${baseUrl}/dashboard/widget/get-key-info-list.do`, {
      objDefineId,
      managetypeId,
      managegroupTotal,
      managegroupIds,
      limit,
    });
  },
  getManagetypeInfo() {
    return axios.get(`${baseUrl}/dashboard/widget/get-managetype-info.do`);
  },
  getNetdeviceRegularCheckList(managegroupTotal, managegroupIds) {
    return axios.post(`${baseUrl}/dashboard/widget/sql-netdevice-regular-check-list.do`, {
      managegroupTotal,
      managegroupIds,
    });
  },
  getComprehensiveInfo(managetypeIds, managegroupIds, managetypeTotal, managegroupTotal) {
    return axios.post(`${baseUrl}/dashboard/widget/get-comprehensive-info.do`, {
      managetypeIds,
      managegroupIds,
      managetypeTotal,
      managegroupTotal,
    });
  },
  getObjtypeStatusInfo(managetypeIds, managegroupIds, managetypeTotal, managegroupTotal, limit) {
    return axios.post(`${baseUrl}/dashboard/widget/get-objtype-status-info.do`, {
      managetypeIds,
      managegroupIds,
      managetypeTotal,
      managegroupTotal,
      limit,
    });
  },
  getEventStatusByLevel(viewType, limit, managegroupIds, managetypeIds, managetypeTotal, managegroupTotal) {
    return axios.post(`${baseUrl}/dashboard/widget/get-event-status-by-level.do`, {
      viewType,
      limit,
      managegroupIds,
      managetypeIds,
      managetypeTotal,
      managegroupTotal,
    });
  },
  getPerformanceChartData(startDatetime, endDatetime, objTotal, objIds, serviceObjIds, managetypeId, rscInfoList, rscKeyInfoList, limit, selectedObjType, isRelative) {
    return axios.post(`${baseUrl}/dashboard/widget/get-performance-analysis-chart-data.do`, {
      startDatetime,
      endDatetime,
      objTotal,
      objIds,
      serviceObjIds,
      managetypeId,
      rscInfoList,
      rscKeyInfoList,
      limit,
      selectedObjType,
      isRelative,
    });
  },
  getQueryPerformanceChartData(selectType, queryId) {
    return axios.post(`${baseUrl}/dashboard/widget/get-performance-analysis-chart-data.do`, {
      selectType,
      queryId,
    });
  },
  getE2ELogicalTreeData(params) {
    return axios.post(`${baseUrl}/dashboard/widget/get-e2e-logical-tree.do`, params);
  },
  getVmStatusInfo(selectType, orderTerm, managegroupTotal, managegroupIds, limit, order) {
    return axios.post(`${baseUrl}/dashboard/widget/get-vm-status-info.do`, {
      selectType,
      orderTerm,
      managegroupTotal,
      managegroupIds,
      limit,
      order,
    });
  },
  getVmsSummaryInfo() {
    return axios.post(`${baseUrl}/dashboard/widget/get-vms-summary-info.do`, {});
  },
  getVmsSnapshoDetailInfo(objId, vmsObjId) {
    return axios.post(`${baseUrl}/dashboard/widget/get-vms-snapshot-detail-info.do`, {
      objId,
      vmsObjId,
    });
  },
  getEmsPhysicalTreeData(params) {
    return axios.get(`${baseUrl}/dashboard/widget/get-ems-physical-tree.do`, {
      params,
    });
  },
  getRealtimeActivespeedInfo(selectedObjType, objId, selectType) {
    return axios.post(`${baseUrl}/dashboard/widget/get-realtime-activespeed-info.do`, {
      selectedObjType,
      objId,
      // isTotal,
      // ids,
      // idType,
      selectType,
    });
  },
  getVisitorCountInfo(selectedObjType, objId, viewTerm) {
    return axios.post(`${baseUrl}/dashboard/widget/get-visitor-count-info.do`, {
      selectedObjType,
      objId,
      // isTotal,
      // ids,
      // idType,
      viewTerm,
    });
  },
  getPocInfo(basicinfoId, basicinfoSubid) {
    return axios.post(`${baseUrl}/dashboard/widget/get-poc-info.do`, {
      basicinfoId,
      basicinfoSubid,
    });
  },
  getHistChartData({ selectType, startDatetime, endDatetime, objTotal, objIds, managetypeId, rscInfoList, rscKeyInfoList, selectedObjType, termType, compareTerm, compareEnabled,
    queryId, querySeriesSize, queryXAxis, serviceObjIds, limit, dataViewPointType }) {
    return axios.post(`${baseUrl}/dashboard/coord/widget/get-hist-chart-data.do`, {
      selectType,
      startDatetime,
      endDatetime,
      objTotal,
      objIds,
      managetypeId,
      rscInfoList,
      rscKeyInfoList,
      selectedObjType,
      termType,
      compareTerm,
      compareEnabled,
      queryId,
      querySeriesSize,
      queryXAxis,
      serviceObjIds,
      limit,
      dataViewPointType,
    });
  },
  getStatusChartData({ selectType, viewType, selectedObjType, managetypeId, managetypeKey, objTotal, objIds, rscInfoList, rscKeyInfoList, order, limit, queryId, querySeriesSize, queryXAxis }) {
    return axios.post(`${baseUrl}/dashboard/coord/widget/get-status-chart-data.do`, {
      selectType,
      viewType,
      selectedObjType,
      managetypeId,
      managetypeKey,
      objTotal,
      objIds,
      rscInfoList,
      rscKeyInfoList,
      order,
      limit,
      queryId,
      querySeriesSize,
      queryXAxis,
    });
  },
  getEventStatusData({ selectType, queryId, managetypeId, managetypeKey, objIds, objTotal, rscTotal, rscInfoList, rscKeyInfoList, eventlevelType, eventlevelIds }) {
    return axios.post(`${baseUrl}/dashboard/coord/widget/get-event-status-data.do`, {
      selectType,
      queryId,
      managetypeId,
      managetypeKey,
      objIds,
      objTotal,
      rscTotal,
      rscInfoList,
      rscKeyInfoList,
      eventlevelType,
      eventlevelIds,
    });
  },
  getEventStatusListData(managetypeId, managetypeKey, objIds, objTotal, rscTotal, rscInfoList, rscKeyInfoList, eventlevelType, eventlevelIds) {
    return axios.post(`${baseUrl}/dashboard/coord/widget/get-event-status-list-data.do`, {
      managetypeId,
      managetypeKey,
      objIds,
      objTotal,
      rscTotal,
      rscInfoList,
      rscKeyInfoList,
      eventlevelType,
      eventlevelIds,
    });
  },
  getPredictEventData({ managegroupTotal, managegroupIds, managetypeTotal, managetypeIds, limit }) {
    return axios.post(`${baseUrl}/dashboard/widget/get-predict-event-data.do`, {
      managegroupTotal,
      managegroupIds,
      managetypeTotal,
      managetypeIds,
      limit,
    });
  },
  getEventGridData({ selectType, queryId, managetypeIds, managetypeTotal, managegroupIds, managegroupTotal, eventlevelType, eventlevelIds, eventListColumnList, limit, dataViewPointType }) {
    return axios.post(`${baseUrl}/dashboard/coord/widget/get-event-grid-data.do`, {
      selectType,
      queryId,
      managetypeIds,
      managetypeTotal,
      managegroupIds,
      managegroupTotal,
      eventlevelType,
      eventlevelIds,
      eventListColumnList,
      limit,
      dataViewPointType,
    });
  },
  getTextPerfData({ selectType, summaryType, managetypeId, managetypeKey, objTotal, objIds, rscInfoList, rscKeyInfoList, queryId }) {
    return axios.post(`${baseUrl}/dashboard/coord/widget/get-text-perf-data.do`, {
      selectType,
      summaryType,
      managetypeId,
      managetypeKey,
      objTotal,
      objIds,
      rscInfoList,
      rscKeyInfoList,
      queryId,
    });
  },
  getSlideWidgetData({ paramList }) {
    return axios.post(`${baseUrl}/dashboard/coord/widget/get-slide-widget-data.do`, {
      paramList,
    });
  },
  getBundleWidgetData({ rotationNumber, paramList, cancelToken }) {
    return axios.post(`${baseUrl}/dashboard/coord/widget/get-bundle-widget-data.do`, {
      rotationNumber,
      paramList,
    }, {
      cancelToken,
    });
  },
  getObjRscKeyList(managetypeId, objIds, rsctypeIds, rscIds) {
    return axios.post(`${baseUrl}/dashboard/widget/get-obj-rsc-key-list.do`, {
      managetypeId,
      objIds,
      rsctypeIds,
      rscIds,
    });
  },
  getManagedObjectWidgetData({ objId }) {
    return axios.post(`${baseUrl}/dashboard/coord/widget/get-managed-object-widget-data.do`, {
      objId,
    });
  },
  getPerfPredictChartData(startDatetime, endDatetime, objTotal, objIds, serviceObjIds, managetypeId, rscInfoList, rscKeyInfoList, limit, selectedObjType) {
    return axios.post(`${baseUrl}/dashboard/widget/get-perf-predict-chart-data.do`, {
      startDatetime,
      endDatetime,
      objTotal,
      objIds,
      serviceObjIds,
      managetypeId,
      rscInfoList,
      rscKeyInfoList,
      limit,
      selectedObjType,
    });
  },
  getClockData() {
    return axios.post(`${baseUrl}/dashboard/coord/widget/get-clock-data.do`, {});
  },
  getInterfaceOperationStatusWidgetData(managegroupIds, selectType, viewType, order) {
    return axios.post(`${baseUrl}/dashboard/coord/widget/get-interface-operation-status-widget-data.do`, {
      managegroupIds,
      selectType,
      viewType,
      order,
    });
  },
  getAuthMapList() {
    return axios.get(`${baseUrl}/dashboard/widget/get-auth-map-list.do`);
  },
  getWirelessDeviceOrderNRscRsltList({ selectType, selectRsctype, managegroupTotal, managegroupIds, selectBandtype, rscKeyTotal, order, limit }) {
    return axios.post(`${baseUrl}/dashboard/widget/get-wireless-device-ordern-rslt-info.do`, {
      selectType,
      selectRsctype,
      managegroupTotal,
      managegroupIds,
      selectBandtype,
      rscKeyTotal,
      order,
      limit,
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/dashboard/widget.js